import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "card w-100" }
const _hoisted_3 = { class: "mx-3 pt-4 text-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "w-50 m-auto patient-title" }
const _hoisted_6 = { class: "mx-5" }
const _hoisted_7 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "rounded-circle mb-3",
          width: "100",
          src: _ctx.patient_image
        }, null, 8, _hoisted_4),
        _createElementVNode("h3", null, _toDisplayString(_ctx.scenario.patient_name), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.scenario.title), 1),
        _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "hr-dark" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatted_field_data, (field) => {
          return (_openBlock(), _createElementBlock("span", {
            key: field.id
          }, [
            _createElementVNode("h4", null, _toDisplayString(field.title), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.fields, (data) => {
              return (_openBlock(), _createElementBlock("div", {
                key: data.id
              }, [
                (field.fields.length > 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                      _createElementVNode("strong", null, _toDisplayString(data.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", {
                  innerHTML: data.value
                }, null, 8, _hoisted_8)
              ]))
            }), 128))
          ]))
        }), 128)),
        _cache[1] || (_cache[1] = _createElementVNode("h4", null, "Visit Objective", -1)),
        _createElementVNode("p", {
          innerHTML: _ctx.scenario.objective
        }, null, 8, _hoisted_9),
        _cache[2] || (_cache[2] = _createElementVNode("h4", null, "Target Audience", -1)),
        _createElementVNode("p", {
          innerHTML: _ctx.scenario.target_audience
        }, null, 8, _hoisted_10)
      ])
    ])
  ]))
}